import alt from '../alt';
import GraphSource from '../sources/graph';

export class GraphActions {

    setLoading(flowId) {
        return flowId;
    }

    setSaving(flowId) {
        return flowId;
    }

    update(graph, flowId) {
        return { graph: graph, flowId: flowId };
    }

    get(id, tenantId, authenticationToken) {
        this.actions.setLoading(id);
        this.dispatch();

        GraphSource.get(id, tenantId, authenticationToken)
            .then(response => this.actions.onGet({ response, tenantId, authenticationToken }));
    }

    onGet(graph) {
        return graph;
    }

    save(id, mapElements, groupElements, tenantId, authenticationToken) {
        this.actions.setSaving(id);
        this.dispatch();

        const graph = {
            id: { id },
            mapElements: (mapElements || []).filter(element => !manywho.utils.isNullOrUndefined(element)),
            groupElements: (groupElements || []).filter(element => !manywho.utils.isNullOrUndefined(element))
        };

        GraphSource.save(id, graph, tenantId, authenticationToken)
            .then(response => {
                this.actions.update(response, id);
                this.actions.onSave(response);
            })
            .catch(error => this.actions.onError(id, error));
    }

    onSave(graph) {
        return { response: graph };
    }

    onError(id, error) {
        return { id, error };
    }

    delete(flowId) {
        return flowId;
    }

    clearAlert(id) {
        return id;
    }
}



export default alt.createActions(GraphActions);
